import actionsPeppol from "./actions";

export default {
  namespaced: true,
  actions: actionsPeppol,
};
